import { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import SignInCard from '../../components/SignInCard';
import Content from '../../components/Content';
import ForgetPassword from '../../components/ForgetPassword';

export default function SignInSide(props) {
  const [step, setStep] = useState('signin'); // 'signin' | 'forget' | 'change'

  return (
    <>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
          (theme) => ({
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: -1,
              inset: 0,
              backgroundImage:
                'radial-gradient(ellipse at 50% 50%, hsl(330, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundRepeat: 'no-repeat',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 50% 50%, hsla(330, 90%, 16%, 0.4), hsl(220, 30%, 5%))',
              }),
            },
          }),
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            p: { xs: 2, sm: 4 },
            m: 'auto',
          }}
        >
          <Content />
          {step === 'signin' && <SignInCard onForgetPassword={() => setStep('forget')} />}
          {step === 'forget' && <ForgetPassword onCodeSent={() => setStep('change')} />}
          {/* {step === 'change' && <ChangePassword onPasswordChange={() => setStep('signin')} />} */}
        </Stack>
      </Stack>
    </>
  );
}
